<template>
  <div class="container" :id="'container'+jwd"></div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  name: "map-view",
  props: {
    jwd: {
      type: String,
      default: "116.42,39.89",
    },
    title: {
      type: String,
      default: "北京",
    },
  },
  mounted() {
    this.initAMap();
  },
  unmounted() {
    this.map?.destroy();
  },
  methods: {
    initAMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "ab75d4b7e7e4455525b81a2f0d0fa078",
      };
      AMapLoader.load({
        key: "47b1a22d36cc11813648fbe4c5029cb2", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          const marker = new AMap.Marker({
            position: new AMap.LngLat(this.jwd.split(',')[0],this.jwd.split(',')[1]), //经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: this.title,
          });

          this.map = new AMap.Map("container" + this.jwd, {
            // 设置地图容器id
            viewMode: "3D", // 是否为3D地图模式
            zoom: 15, // 初始化地图级别
            center: this.jwd.split(','), // 初始化地图中心点位置
          });
          this.map.add(marker);
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style scoped>
.container {
  width: 100% !important;
  height: 230px;
  border-radius: 1rem !important;
}
</style>
